import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import store, { persistor } from "./Redux/store";
import { isLocalhost } from "./Utils/Constants/Constants";
import App from "./App";
import "./index.css";

const isMobile =
  /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  ) ||
  isLocalhost ||
  Boolean(window.Cypress);

function DesktopBlocker() {
  return (
    <div className="desktop-blocker">
      <svg viewBox="0 0 24 24">
        <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
        <line x1="12" y1="18" x2="12.01" y2="18" />
      </svg>
      <p>InfraNex Vantage is designed for mobile devices. Please open this app on your phone.</p>
    </div>
  );
}

ReactDOM.render(
  <React.StrictMode>
    {isMobile ? (
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <App />
        </PersistGate>
      </Provider>
    ) : (
      <DesktopBlocker />
    )}
  </React.StrictMode>,
  document.getElementById("root")
);
